import React from "react";
import { Link, useLocation } from "react-router-dom";
import "./Footer.css";

const AUTH_PREFIXES = [
  "/dashboard",
  "/admin",
  "/tutor-portal",
  "/mentor-portal",
  "/manager-portal",
  "/parent-",
  "/student-",
  "/inbox",
  "/change-password",
  "/subscriptions",
  "/curricula",
  "/my-assignments",
  "/grading",
  "/student-load",
];

const Footer: React.FC = () => {
  const location = useLocation();

  const isAuthPage = AUTH_PREFIXES.some((prefix) =>
    location.pathname.startsWith(prefix),
  );

  if (isAuthPage) {
    return null;
  }

  return (
    <footer className="site-footer" data-testid="site-footer">
      <div className="footer-container">
        <div className="footer-columns">
          <div className="footer-column">
            <h3>Platform</h3>
            <ul>
              <li>
                <Link to="/" data-testid="footer-home-link">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/courses" data-testid="footer-courses-link">
                  Courses
                </Link>
              </li>
              <li>
                <Link to="/registrations" data-testid="footer-contests-link">
                  Contests
                </Link>
              </li>
              <li>
                <Link to="/blogs" data-testid="footer-blogs-link">
                  Blogs
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Resources</h3>
            <ul>
              <li>
                <Link
                  to="/opportunities"
                  data-testid="footer-opportunities-link"
                >
                  Opportunities
                </Link>
              </li>
              <li>
                <Link to="/forums" data-testid="footer-forums-link">
                  Forums
                </Link>
              </li>
              <li>
                <Link to="/faq" data-testid="footer-faq-link">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/videos" data-testid="footer-videos-link">
                  Videos
                </Link>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/@yourfutureprep?utm_source=yourfutureprep.com&utm_medium=footer"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-youtube-link"
                  aria-label="YourFuturePrep YouTube channel"
                >
                  YouTube Channel
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Company</h3>
            <ul>
              <li>
                <Link to="/about" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" data-testid="footer-contact-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3>Legal</h3>
            <ul>
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 YourFuturePrep. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
